export default __webpack_public_path__ + "static/media/ttg-dropdown.7fb35cc5.webp";